import { AppContext } from "@lightspeed-invoicing/core-client/frontend/index"

export const PRICING_TABLE_COOKIE_KEY = "qm_pt_data"
export const CHECKOUT_COOKIE_KEY = "qm_ck_data"

export const clearCookies = (cookieKey: string) => {
    AppContext.setCookie(cookieKey, "")
}


// WEBPACK FOOTER //
// ./src/price-list/helpers/utils.ts